var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-card-text", [
        _c(
          "div",
          { staticClass: "d-flex align-center gap-2" },
          [
            _c("v-icon", { attrs: { color: "success", size: "20" } }, [
              _vm._v(" circle "),
            ]),
            _c("span", { staticClass: "green--text text--accent-4" }, [
              _vm._v(" เชื่อมต่อสำเร็จ "),
            ]),
            _c("v-spacer"),
            _c("snt-confirm-dialog", {
              attrs: {
                title: `ยืนยันการ Log out หรือไม่?`,
                description:
                  "หากคุณกด Log out แล้ว ข้อมูลจะไม่เชื่อมต่อกับ PEAK อีก",
                "content-width": "300px",
                "confirm-text": "ยืนยัน",
              },
              on: {
                confirm: function ($event) {
                  return _vm.logout()
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on, attrs }) {
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              attrs: {
                                loading: _vm.submitting,
                                color: "primary",
                                outlined: "",
                              },
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [_vm._v(" Log out ")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }